// extracted by css-extract-rspack-plugin
export default {"ChartCardTitleHeading":"Title-module__ChartCardTitleHeading__o6EgM"};